import { Button, Modal } from 'react-bootstrap';

function ConfirmationModal({ show, handleClose, handleConfirm, message }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmación requerida</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="info" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="info" onClick={handleConfirm}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;
